// JsFromRoutes CacheKey f8c2171cfd9ecb1d500f6a3877324f90
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  handleFolderDeletion: definePathHelper('post', '/folders/handle_folder_deletion.html'),
}
